export const MenuItems = [
    {
      title: 'UI - UX Team',
      path: '/#',
      cName: 'dropdown-link'
    },
    {
      title: 'Design Team',
      path: '/#',
      cName: 'dropdown-link'
    },
    {
      title: 'Front End Team',
      path: '/#',
      cName: 'dropdown-link'
    },
    {
      title: 'Back End Team',
      path: '/#',
      cName: 'dropdown-link'
    },
    {
      title: 'CI - CD Team',
      path: '/#',
      cName: 'dropdown-link'
    },
    {
      title: 'Testing Team',
      path: '/#',
      cName: 'dropdown-link'
    }
  ];